/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Activity_Actor_SystemInputs */



/**
* | output |
* | --- |
* | "System" |
*
* @param {Partner_Activity_Actor_SystemInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_activity_actor_system = /** @type {((inputs?: Partner_Activity_Actor_SystemInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Activity_Actor_SystemInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("System")
	return /** @type {LocalizedString} */ ("System")
});